// extracted by mini-css-extract-plugin
export default {"btn":"index_btn__hWSTm"};